import { render } from "./NewWalls.vue?vue&type=template&id=1bb09b80&scoped=true"
import script from "./NewWalls.vue?vue&type=script&lang=js"
export * from "./NewWalls.vue?vue&type=script&lang=js"

import "./NewWalls.vue?vue&type=style&index=0&id=1bb09b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb09b80"]])

export default __exports__